/* eslint import/no-webpack-loader-syntax: off */
require('expose-loader?BVFetch!../src/utils/fetch');
